import useApiMutation from 'shared/hooks/use-api-mutation';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import usersKeys from '../util/users-keys';
import {UserProps} from '../types';

const useEditProfile = () => {
  const {setData} = useQueryHelpers();

  const onSuccess = (data: UserProps) => {
    setData(usersKeys.profile(), data);
  };

  return useApiMutation<UserProps>({
    url: '/users/me',
    method: 'PATCH',
    errorTitle: 'Erro ao editar perfil',
    successTitle: 'Editar perfil',
    successMessage: 'Perfil atualizado com sucesso',
    onSuccess,
  });
};

export default useEditProfile;
